import highlighter from '../utils/rbmc.highlighter';
import urlUtils from '../utils/rbmc.url-utils';
import cookieUtils from '../utils/rbmc.cookie-utils';
import searchBox from './rbmc.search-box';
import logger from '../utils/rbmc.logger';

const searchUtils = {
    searchBox:                  undefined,
    searchOptions:              undefined,
    searchTerm:                 undefined,
    autocompleteUrl:            undefined,
    displayProductImages:       undefined,
    minCharactersBeforeRequest: undefined,
    maxProductsToShow:          undefined,
    waitTimeBeforeRequest:      undefined,
    searchPageUrl:              undefined,
    suggestSearchWrapper:       undefined,
    suggestProductWrapper:      undefined,
    suggestProductPoll:         undefined,
    suggestPoll:                undefined,
    totalProductResult:         undefined,
    showAllSearch:              undefined,
    subShop:                    undefined,

    /**
     * Expects search term/query form search input field.
     * @param searchQuery
     */
    dispatchSearchActions() {
        if (this.searchTerm.length >= searchUtils.searchOptions.minCharactersBeforeRequest) {
            // Fetch results from backend
            const searchResult = this.executeSearch(this.searchTerm);
            searchUtils.setParamsBasedOnSearchTerm(this.searchTerm);
            searchResult.done(function (response) {
                searchUtils.clearSuggestionPolls();
                const hasSuggestions = (response.suggestions !== []) && response.suggestions.length;
                const hasProducts    = (response.products !== []) && response.products.length;

                if (!!hasSuggestions) {
                    $.each(response.suggestions, function (index, suggestion) {
                        searchUtils.suggestPoll.append(searchUtils.suggestSearchTermTemplate(suggestion, searchUtils.searchTerm));
                    });
                    searchUtils.showSuggestSearch();
                    searchUtils.showNoResults(false);
                } else {
                    searchUtils.showNoResults();
                }

                if (!!hasProducts) {
                    searchUtils.totalProductResult.text(`(${response.totalNumberOfProducts})`);
                    $.each(response.products, function (index, product) {
                        if (index > searchUtils.searchOptions.maxProductsToShow) {
                            return false;
                        }
                        searchUtils.suggestProductPoll.append(searchUtils.suggestSearchProductTemplate(product));
                    });
                    searchUtils.showSuggestSearch();
                    searchUtils.showProductsSuggestion();
                } else {
                    searchUtils.showProductsSuggestion(false);
                    if (!!hasSuggestions === false) {
                        searchUtils.showSuggestSearch(false);
                    }
                }
            });

            searchResult.fail(function (error) {
                logger.log(`Search action failed, error details: `, error);
            });
        } else {
            searchUtils.resetSuggestSearch();
        }

    },

    /**
     * Used for sending AJAX get request with search term and subshop id params.
     * Returns ajax object.
     * @param searchTerm
     * @param subshop
     * @returns {*}
     */

    executeSearch(searchTerm) {
        return $.get(`${urlUtils.getSiteOrigin()}${searchUtils.searchOptions.autocompleteUrl}`,
                searchUtils.subShop ? {term: searchTerm, subshop: searchUtils.subShop} : {term: searchTerm});
    },

    /**
     * Requires string - whole search result form BE and term - search term from search input field.
     * It returns HTML template for single result with highlighted text.
     * @param string
     * @param term
     * @returns string
     */
    suggestSearchTermTemplate(string, term) {
        return `<p class="search-component__suggestion selectable" data-suggestion="${string.term.trim()}">
                    ${highlighter.highlightText(string.term, term)}
                </p>`;
    },

    /**
     * Requires product object from BE to pass, returns HTML template for single product.
     * @param product
     * @returns string
     */
    suggestSearchProductTemplate(product) {
        const fakeBg   = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';
        const imageObj = product.images.filter(image => image.imageType === "CART")[0];
        const image    = {
            url: imageObj ? imageObj.url : fakeBg,
            alt: imageObj ? imageObj.altText : ""
        }
        return `<a href="${urlUtils.getSiteOrigin()}${ACC.config.encodedContextPath}${product.url}">
                    <div class="search-component__product-wrapper selectable" data-code="${product.code}">
                        <div class="search-component__product-image">
                            <img src="${image.url}" alt="${image.alt}">
                        </div>
                        <div class="search-component__product-description">
                            <p class="search-component__product-gender">${product.gender.name}</p>
                            <p class="search-component__product-name">${product.name}</p>
                        </div>
                    </div>
                </a>`;
    },

    /**
     * By default on call is true - removes hidden class for search suggestion wrapper, pass false to hide panel.
     * @param visible
     */
    showSuggestSearch(visible = true) {
        const suggestHiddenClass = 'search-component__suggest-results--hidden';
        if (visible) {
            searchUtils.searchBox.parents('.search-component__form').addClass("has-suggestions");
            this.suggestSearchWrapper.removeClass(suggestHiddenClass);

            // If search is under 50% of page and has results, scroll it to top (right on edge on header)
            const halfWindowHeight  = $(window).height() / 2; // Need to check always in case of device rotate
            const headerHeight      = $('.page-header').height() // Need to check always in case of device rotate.
            const searchBoxPosition = searchUtils.searchBox.offset().top;
            const correctionFactor  = 30;

            if (searchBoxPosition - window.scrollY > halfWindowHeight && !searchBox.globalSearchVisible) {
                searchBox.$html.animate({scrollTop: searchBoxPosition - headerHeight - correctionFactor}, 500)
            }

        } else {
            this.suggestSearchWrapper.addClass(suggestHiddenClass)
            searchUtils.searchBox.parents('.search-component__form').removeClass("has-suggestions");
        }
    },

    /**
     * By default on call is true - removes hidden class for search product suggestion wrapper, pass false to hide panel.
     * @param visible
     */
    showProductsSuggestion(visible = true) {
        const suggestProductShowClass = 'search-component__suggest-results-with-products';
        if (visible) {
            this.suggestSearchWrapper.addClass(suggestProductShowClass);
        } else {
            this.suggestSearchWrapper.removeClass(suggestProductShowClass)
        }
    },

    /**
     * By default on call is true - removes hidden class for search no result, pass false to hide panel.
     * @param visible
     */
    showNoResults(visible = true) {
        const noResultsClass = 'search-component__no-result--mobile--visible';
        if (!!this.noResults) {
            if (visible) {
                this.noResults.addClass(noResultsClass);
            } else {
                this.noResults.removeClass(noResultsClass)
            }
        }
    },

    /**
     * Clears product result and search results.
     */
    clearSuggestionPolls() {
        searchUtils.suggestProductPoll.empty();
        searchUtils.suggestPoll.empty();
        searchUtils.totalProductResult.text('(0)');
    },

    /**
     * Calls searchUtils.clearSuggestionPolls() and hides suggestion and product result section.
     */
    resetSuggestSearch() {
        this.clearSuggestionPolls();
        this.showSuggestSearch(false);
        this.showProductsSuggestion(false);
    },

    /**
     * This metod is used to populate parts of DOM which depends on search term.
     * @param searchTerm
     */
    setParamsBasedOnSearchTerm(searchTerm) {
        searchUtils.showAllSearch.attr('href', searchBox.getSearchUrl(searchTerm));
    },

    /**
     * Init of jQuery selectors for search suggestion actions.
     * This should bind events for every global and subshop search.
     */
    init($searchBox) {
        /**
         * Search config/options object have next properties:
         * autocompleteUrl: string
         * displayProductImages: boolean
         * minCharactersBeforeRequest: number
         * waitTimeBeforeRequest: number
         */
        const $searchBoxWrapper         = $searchBox.parents('.search-component--suggest');
        this.searchBox                  = $searchBox;
        this.searchTerm                 = $searchBox.val();
        this.searchOptions              = $searchBox.data('options');
        this.autocompleteUrl            = this.searchOptions.autocompleteUrl;
        this.displayProductImages       = this.searchOptions.displayProductImages;
        this.minCharactersBeforeRequest = this.searchOptions.minCharactersBeforeRequest;
        this.maxProductsToShow          = this.searchOptions.maxProducts;
        this.waitTimeBeforeRequest      = this.searchOptions.waitTimeBeforeRequest;
        this.searchPageUrl              = $searchBox.parent().attr('action');
        this.suggestSearchWrapper       = $searchBoxWrapper.find('.search-component__suggest-results');
        this.suggestProductWrapper      = $searchBoxWrapper.find('.search-component__products');
        this.suggestProductPoll         = $searchBoxWrapper.find('.search-component__products-pool');
        this.suggestPoll                = $searchBoxWrapper.find('.search-component__suggestions');
        this.totalProductResult         = $searchBoxWrapper.find('.search-component__product-number');
        this.showAllSearch              = $searchBoxWrapper.find('.search-component__show-all');
        this.noResults                  = $searchBoxWrapper.find('.search-component__no-result--mobile');
        this.subShop                    = cookieUtils.getFirstCookieValue('subShop');
        this.dispatchSearchActions();
    },
}

export default searchUtils;